import React from 'react'
import {
    AllEvents,
    BreakingNewsCard,
    createCardClickedEvent,
    useFeature,
} from '@news-mono/web-common'
import {
    MiniWaFootyLivesHereIcon,
    StyledFootyLivesHerePromoStrapContainer,
    StyledFootyLivesHereText,
    StyledInnerContainer,
    StyledInnerTextContainer,
} from './FootyLivesHerePromoStrap.styled'
import { useViewport } from '../../__helpers/use-viewport'

export interface FootyLivesHerePromoStrapProps {
    bannerLink: string
    text: string
    onEvent: (event: AllEvents) => void
    impressionRef: React.RefObject<HTMLDivElement>
}

export const FootyLivesHerePromoStrap = ({
    bannerLink,
    text,
    onEvent,
    impressionRef,
}: FootyLivesHerePromoStrapProps) => {
    const { isMobile } = useViewport()
    const hideOnMobileAndApp = useFeature(
        'hide-mobile-breaking-news-banner',
        true,
    )

    const item: BreakingNewsCard = {
        shortHeadline: 'FOOTY LIVES HERE',
        link: bannerLink,
        cardType: 'breaking-news',
        listId: 'footy-lives-here-promo-strap',
    }
    const linkClicked = () => {
        onEvent(
            createCardClickedEvent(
                onEvent,
                item,
                'FootyLivesHerePromoStrap',
                'FootyLivesHerePromoStrap',
                1,
            ),
        )
    }

    // Splits the text into parts, wrapping "save up to 25%" in a span so it can have different styles applied
    const highlightedText = text.split(/(save up to 25%)/i).map((part, index) =>
        // Target the "save up to 25%" part (which will be at odd indices) even when repeated
        index % 2 === 1 ? <span key={index}>{part}</span> : part,
    )

    return (
        <div ref={impressionRef}>
            <StyledFootyLivesHerePromoStrapContainer
                hideOnMobileAndApp={hideOnMobileAndApp}
                href={bannerLink}
                onClick={linkClicked}
            >
                <StyledInnerContainer>
                    <MiniWaFootyLivesHereIcon />
                    <StyledInnerTextContainer>
                        <StyledFootyLivesHereText>
                            {highlightedText}
                        </StyledFootyLivesHereText>
                    </StyledInnerTextContainer>
                    {!isMobile && <MiniWaFootyLivesHereIcon />}
                </StyledInnerContainer>
            </StyledFootyLivesHerePromoStrapContainer>
        </div>
    )
}
